export enum ArchiveVisualsTag {
  ADMIN_ARCHIVE = 'ADMIN_ARCHIVE',
  CLIENT_ARCHIVE = 'CLIENT_ARCHIVE',
}